import logo from './logo.svg';
import './App.css';
import Pathfinder from './pathfinder_folder/Pathfinder'

function App() {
  return (
    <Pathfinder></Pathfinder>
  );
}

export default App;
